module.exports = __webpack_public_path__ + "img/LogoMastercard_Color.ec88141d.png";